const per = 25;

export { per };
